import React, { useEffect, useRef, useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import MtfLas from "./MtfLas";
import SlabWise from "./SlabWise";
import Mastertable from "./Mastertable";
import AmcApMaster from "./AmcApMaster";
import axios from "axios";
import { AP_Master } from "../../Configuration/API_URL";
import { Constants } from "../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import SearchCommon from "../../Components/SearchCommon";
import SegmentDropDown from "../../Components/SegmentDropDown";
import { useNavigate } from "react-router-dom";
import BrokerageTableApMaster from "./BrokerageTableApMaster";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import {
  AESEncryption,
  ApiResDecrypt,
  inputPanVal,
  validateIfsc,
} from "../../CommonMethhods/CommonMethods";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import AttachmentFile from "../../asset/images/Vector.svg";
// import searchIfsc from "../../asset/images/search-blue.svg";
import searchIfsc from "../../asset/images/search-blue.svg";
import SmallLoader from "../../Components/Common/smallLoader";
import { Modal } from "react-bootstrap";
import searchIcon from "../../asset/images/search-icon.svg";
import { useDebounce } from "../../Components/useDebounce";
import { useAsync } from "react-async";

function ApMaster() {
  var biRef = {};
  const navigate = useNavigate();
  // const [selectBrokerage, setSelectBrokerage] = useState("");
  let apCodeChild = "";
  let subApCode = "";
  var segementIdChild = [];
  var hiRef = {};
  const [updateData, setUpdateData] = useState({});
  const [submitBtn, setSubmitBtn] = useState(true);
  const [apDropdown, setApDropdown] = useState({});
  const [clientPage, setClientPage] = useState(1);
  const [clientShow, setClientShow] = useState(false);
  const [fixScroll, setFixScroll] = useState(false);
  const ClientCodeRef = useRef("");
  // const apTypeRef = useRef("");
  const exchangeDropdownRef = useRef(null);
  const [exchangeShow, setExchangeShow] = useState(false);
  const apCodeFromChildRef = useRef("");
  const [master, setMaster] = useState("ApMaster");
  const [scrollClientLoader, setScrollClientLoader] = useState(false);
  const [errorClientName, setErrorClientName] = useState("");
  const [clientCount, setClientCount] = useState();
  const [clientDropDown, setClientDropDown] = useState([]);
  const [loaderBrowsFile, setLoaderBrowsFile] = useState(false);
  const [ifscLoader, setIfscLoader] = useState(false);
  const [uploadGstLoader, setUploadGstLoader] = useState(false);
  const [canChequeLoader, setCanChequeLoader] = useState(false);

  const [fileUrl, setFileUrl] = useState("");
  const [exchangeId, setExchangeId] = useState([]);
  const [exchangeName, setExchangeName] = useState([]);
  const [errorExchange, setErrorExchange] = useState(false);
  const [showIfscModal, setShowIfscModal] = useState(false);
  const [bankNameVal, setBankNameVal] = useState("");
  const [branchLocationVal, setBranchLocationVal] = useState("");
  const [show, setShow] = useState(false);
  const [showBranch, setShowBranch] = useState(false);
  const [bankNameData, setBankNameData] = useState([]);
  const [branchLocData, setBranchLocData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageBranch, setPageBranch] = useState(1);
  const [count, setCount] = useState();
  const [branchCount, setBranchCount] = useState();
  const [scrollLoader, setScrollLoader] = useState(false);
  const [scrollBranchLoader, setBranchScrollLoader] = useState(false);
  const [bankNameErr, setBankNameErr] = useState(false);
  const [branchLocErr, setBranchLocErr] = useState(false);
  const [ifscVal, setIfscVal] = useState("");
  const [bankErr, setBankErr] = useState("");
  const [branchErr, setBranchErr] = useState("");
  const [bankNameIfsc, setBankNameIfsc] = useState("");
  const [bankVeriModal, setBankVeriModal] = useState(false);
  const [gstRegisterValue, setGstRegisterValue] = useState("");
  const [impsVerify, setImpsVerify] = useState(false);
  const [tableData, setTableData] = useState([])
  // const [accessVal, setAccessVal] = useState();
  // const projectRole = JSON.parse(localStorage.getItem("project"));
  // const getRole = projectRole[0]?.Role?.Name;
  const getRole = localStorage.getItem("cosmosProjectRole");


  const debouncedValue = useDebounce(bankNameVal, 1000);
  const debouncedBranchValue = useDebounce(branchLocationVal, 1000);
  useEffect(() => {
    handlebranchLocation(debouncedBranchValue);
  }, [debouncedBranchValue]);

  useEffect(() => {
    handleBankName(debouncedValue);
  }, [debouncedValue]);

  const masterSet = (data) => {
    setMaster(data);
  };


  function checkAccess(value) {
    // setAccessVal(value);
    localStorage.setItem("accessRole", value)
  }

  useEffect(() => {
    setValue("impsVerify", impsVerify); // Update form state
  }, [impsVerify]);
  const apMasterMainSchema = Yup.object()
    .shape({
      mainApName: Yup.string().notRequired(""),
      mainApCode: Yup.string().required("*Please Enter Ap Code"),
      mainProductBrokerage: Yup.string(),
      mainSegment: Yup.string().required("*Please Select Segments"),
    })
    .when((value, schema) => {
      if (master === "ApMaster") {
        return schema.shape({
          panNumber: Yup.string()
            .required("*PAN Number is a required field.")
            .matches(
              /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
              "*Please enter 10 Character valid PAN number without white space"
            ),
          bankAccNumber: Yup.string()
            .required("*Please Enter Bank Acc. Number")
            .matches(
              "^[0-9]{9,18}$",
              "*Please enter 9 digits to 18 digits without white space"
            ),
          ifscCode: Yup.string()
            .required("*Please Enter IFSC Code")
            .matches(
              "^[A-Z]{4}0[A-Z0-9]{6}$",
              "*Please Enter valid IFSC code without white space"
            ),
          bankName: Yup.string()
            .required("*Please Enter Bank Name")
            .matches(/^[a-zA-Z ]{2,30}$/, "*Please enter Valid Bank Name"),
          apRegister: Yup.string().required("*Please Select Yes/No"),
          gstRegister: Yup.string().required("*Please Select Yes/No"),
          gstNumber: Yup.string().when("gstRegister", {
            is: "yes",
            then: Yup.string()
              .required("*Please Enter GST Number")
              .matches(
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}$/,
                "*Please Enter correct GST number"
              ),
            otherwise: Yup.string().notRequired(""),
          }),

          sapCodes: Yup.string().notRequired(""),
          registrationNo: Yup.string().notRequired(""),
          inputFileGst: Yup.string().when("gstRegister", {
            is: "yes",
            then: Yup.string().required("*Please upload GST document"),
            otherwise: Yup.string().notRequired(""),
          }),

          inputFileCheque: Yup.string().when("$impsVerify", {
            is: true,
            then: Yup.string().required("*Please upload Cancelled cheque"),
            otherwise: Yup.string().notRequired(""),
          }),

          inputFileCommercial: Yup.string(),
          // inputFileCheque: Yup.string().required("*Please upload Cancelled cheque"),

          // commercialUpload: Yup.mixed()
          // .test(
          //   "Added Image",
          //   "*Mandatory to select File",
          //   (value) => value.length > 0
          // )
          // .test(
          //   "is-valid-size",
          //   "*Please select file less than 5MB",
          //   (value) => {
          //     return isValidSize(value);
          //   }
          // ),
          mainApType: Yup.string().required("*Please Select Ap Type"),
        });
      }
      if (master === "ClientMaster") {
        return schema.shape({
          mainClientCode: Yup.string().required("Please Select Client Code"),
        });
      }
      if (value.mainApType == "1" && master === "ApMaster") {
        return schema.shape({
          mainSubApType: Yup.string().required("Please Select Master AP"),
        });
      }
    });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    reset: resetForm,
    getValues,
    watch,
    trigger
  } = useForm({ resolver: yupResolver(apMasterMainSchema), context: { impsVerify }, });
  const productBrokerage = watch("mainProductBrokerage");
  const apType = watch("mainApType");
  useEffect(() => { }, [productBrokerage, apType]);

  function forUpdateMaster(data) {
    hiRef.closeSegmentDropdown();
    setUpdateData(data);
    resetForm({
      mainApName: data.apName,
      mainApCode: data.apCode,
      mainSegment: data.segment,
      mainSubApType: data.masterAP,
      mainApType: data.apType.apId.toString(),
      gstNumber: data.gstNo,
      sapCodes: data.sapCode,
      registrationNo: data.regNo,
      ifscCode: data.ifscCode,
      apRegister: data.isAPRegistered?.toLowerCase(),
      gstRegister: data.isGSTRegistered?.toLowerCase(),
      panNumber: data.pan,
      bankName: data.bankName,
      bankAccNumber: data.accountNo,
      inputFileGst: data.gstDocFileName,
      inputFileCommercial: data.commUploadFileName,
      inputFileCheque: data.canChequeFileName,
    });
    setFileUrl(data.fileName);

    setSubmitBtn(false);
    setTimeout(() => {
      hiRef.forUpdateName(data);
    }, 500);
    hiRef.forUpdateSegmentChild(data.segment);
    forUpdateExchangeChild(data.exchange);
    setClientDropDown({
      0: {
        clientCode: data.clientCode,
        clientName: data.clientName,
      },
    });
    if (master === "ClientMaster") {
      setTimeout(() => {
        ClientCodeRef.current.value = data.clientCode;
        setValue("mainClientCode", data.clientCode);
      }, 500);
    }
    setValue("mainApCode", data.apCode);
    setValue("mainSubApType", data.masterAP);
    setValue("mainProductBrokerage", data.brokerage.bid.toString());
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function resetButton() {
    setGstRegisterValue("");
    // setSelectBrokerage("");
    resetForm({
      gstNumber: "",
      // commercialUpload: "",
      sapCodes: "",
      registrationNo: "",
      inputFileGst: "",
      inputFileCommercial: "",
      inputFileCheque: "",
      ifscCode: "",
      apRegister: "",
      gstRegister: "",
      panNumber: "",
      bankName: "",
      bankAccNumber: "",
      mainApType: "",
      mainApCode: "",
      // mainProductBrokerage: "",
    });
    clearErrors();
    // setValue("mainApType", "");
    hiRef.forUpdateName(false);
    hiRef.forUpdateSegmentChild([]);
    forUpdateExchangeChild([]);
    setSubmitBtn(true);
    setErrorExchange(false);
    if (master === "ClientMaster") {
      onChangeClientDropdownReset();
    }
    document.querySelector("#Input_Segment").value = "";
    setExchangeId([]);
    setExchangeName([]);
    if (document.querySelector("#Input_Exchange")) {
      document.querySelector("#Input_Exchange").value = "";
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const forGetApCode = (code) => {
    apCodeChild = code;
    setValue("mainApCode", code);
    return code;
  };
  const forGetSubApCode = (masterAp) => {
    subApCode = masterAp;
    setValue("mainSubApType", masterAp);
  };
  function forSegement(data) {
    setValue("mainSegment", data.join(","));
  }

  const storeToken = localStorage.getItem("ssoToken");

  const handleClientMasterBrokerage = (clientCode) => {
    if (clientCode !== "") {
      ClientCodeRef.current.value = clientCode;
      setValue("mainClientCode", clientCode);
      BrokerageWiseModulesForClient(apCodeChild, clientCode);
      setScrollClientLoader(false);
    }
  };

  //BrokerageWiseModulesForClient api start

  //Brokerage api Integration start
  const getBrokerageModule = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.BrokerageWiseModules_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getModules?.data);
      if (res?.status === 0) {
        setApDropdown(res?.data);
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/");
      }
      console.log(error);
    }
  };

  const BrokerageWiseModulesForClient = async (ApCode, ClientCode) => {
    let payloadValue = { apCode: ApCode, clientCode: ClientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.BrokerageWiseModulesForClient_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getModules?.data);

      const res = response.data;
      if (res.status === 0) {
        let Data = res.clientAp[0];
        setUpdateData(Data);
        hiRef.forUpdateName(Data);
        hiRef.forUpdateSegmentChild(Data.segment);
        setValue("mainApType", Data.apType.apId);
        setValue("mainProductBrokerage", Data.brokerage.bid.toString());

        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        setValue("mainProductBrokerage", "");
        setUpdateData({});

        hiRef.forUpdateSegmentChild([]);
        setValue("mainApType", "");
      }
    } catch (error) { }
  };
  useEffect(() => {
    getBrokerageModule();
  }, []);

  //client master api start
  const GetClientCodes = async (apCodes, search = "") => {
    let payloadValue = {
      apCodes: apCodes,
      pageSize: 10,
      pageNo: clientPage,
      search: search,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.GetClientCodes_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getModules?.data);
      if (response.status === 0) {
        setClientCount(response.data.totalCount);
        if (fixScroll === true) {
          setClientDropDown((prev) => {
            return [...prev, ...response.data.clientCodes];
          });
        } else {
          setClientDropDown(response.data.clientCodes);
        }
      } else {
        setClientDropDown([]);
        setErrorClientName("No data found");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollClientLoader(false);
    }
  };
  //client master api end

  const handleScrollClientName = async () => {
    setFixScroll(true);
    const a = document.querySelector("#browsers-ClientMaster");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (clientCount <= clientPage * 10) {
        setScrollClientLoader(false);
        return;
      }
      setClientPage((prev) => prev + 1);
      setScrollClientLoader(true);
    }
  };
  useEffect(() => {
    if (clientShow && clientPage > 1) {
      GetClientCodes(apCodeChild, ClientCodeRef.current.value);
    }
  }, [clientPage]);

  function filterBidName(data, name) {
    if (data) {
      let dataArray = data.filter((data) => data.bname == name);
      return dataArray[0];
    }
  }
  const apMasterForm = async (value) => {
    let mainType = getValues("mainApType");
    let mainSegmentType = getValues("mainSegment");
    let mainBrokerage = getValues("mainProductBrokerage");
    let data;

    console.log("mainbrokerage", data)
    // if (mainBrokerage === "1") {
    //   data = biRef.manageMtfData();
    // } else if (mainBrokerage === "2") {
    //   data = biRef.manageSlabWiseData();
    // } else if (mainBrokerage === "3") {
    //   data = biRef.manageAmcData();
    // } else
    if (mainBrokerage === "4") {
      data = biRef.manageBrokerageData();
    }

    if (master === "ApMaster") {
      if (
        apCodeChild &&
        mainBrokerage &&
        mainSegmentType.length > 0 &&
        // apTypeRef.current.value.length > 0 &&
        mainType.length > 0 &&
      ( data || tableData)
        // exchangeId.length > 0
      ) {
        if (parseFloat(data?.slabwiseFrom) >= parseFloat(data?.slabwiseTo)) {
          toast.error("From amount should be less than To amount");
        } else {
          if (impsVerify === false) {
            const isVerified = await getImpsVerification();
            // }
            if (isVerified) {
              apMasterSubmit(data, mainBrokerage);
            } else {
              // if (impsVerify === true && !getValues("inputFileCheque")) {
              //   toast.error("Please upload Cancelled cheque.");
              // } else if (impsVerify === true && getValues("inputFileCheque")) {
              //   apMasterSubmit(data, mainBrokerage);
              // }
            }
          } else {
            if (impsVerify === true && !getValues("inputFileCheque")) {
              toast.error("Please upload Cancelled cheque.");
            } else if (impsVerify === true && getValues("inputFileCheque")) {
              apMasterSubmit(data, mainBrokerage);
            }
          }
        }
      } else {
        toast.error("All fields are mandatory");
      }
    } 
    else {
      if (
        apCodeChild &&
        mainBrokerage &&
        mainSegmentType.length > 0 &&
        ClientCodeRef.current.value.length > 0 &&
        data 
      ) {
        if (parseFloat(data.slabwiseFrom) >= parseFloat(data.slabwiseTo)) {
          toast.error("From amount should be less than To amount");
        } else {
          apMasterSubmit(data, mainBrokerage);

          // const isVerified = await getImpsVerification();
          // if (isVerified) {
          //   apMasterSubmit(data, mainBrokerage);
          // }
        }
      } else {
        toast.error("All fields are mandatory");
      }
    }
  };

  const onChangeClientDropdownReset = () => {
    setScrollClientLoader(false);
    setClientDropDown([]);
    setErrorClientName("");
    setValue("mainClientCode", "");
    ClientCodeRef.current.value = "";
  };

  const showClientList = () => {
    setClientShow(true);
  };

  const getImpsVerification = async () => {
    let payloadValue = {
      ifsc: getValues("ifscCode"),
      acNo: getValues("bankAccNumber"),
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.ImpsBankVerify_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getModules?.data);
      if (response?.status === 0) {
        // setIfscVal(response?.data);
        return true;
      } else {
        setBankVeriModal(true);
        // toast.error(response?.message);
        return false;
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/");
      }
      toast.error("Something went wrong, please try again later.")
      console.log(error);
      return false;
    }
  };

  function handleClientName(e) {
    e.target.value = e.target.value.toUpperCase();
    setClientDropDown([]);
    setClientPage(1);
    if (apCodeChild) {
      setClientPage(1);
      setFixScroll(false);
      GetClientCodes(apCodeChild, e.target.value);
    }
    if (e.target.value === "") {
      setErrorClientName(false);
    }
  }
  const apMasterSubmit = async (data, selectBrokerage) => {
    console.log("data ap master", selectBrokerage, data)
    let reqObj = {};
    let bodyObj = {};
    if (selectBrokerage === "1") {
      reqObj = {
        id: parseFloat(data.id),
        mtfSharing: parseFloat(data.mtfWiseSharing) ||0,
        mtfBaseRate: parseFloat(data.mtfWiseBaseRate)||0,
        lasBaseRate: parseFloat(data.lasWiseBaseRate)||0,
        lasSharing: parseFloat(data.lasWiseSharing)||0,
      };
    } else if (selectBrokerage === "2") {
      if (data?.id == "2") {
        reqObj = {
          // ...sample,
          id: parseFloat(data.id),
          sharing: parseFloat(data.slabwiseSharing)||0,
          from: 0 || parseFloat(data.slabwiseFrom)||0,
          to: 0 || parseFloat(data.slabwiseTo)||0,
        };
      } else {
        reqObj = {
          // ...sample,
          id: parseFloat(data.id),
          sharing: parseFloat(data.slabWishSharing) ||0,
          trade: parseFloat(data.slabWishTrade) ||0,
          del: parseFloat(data.slabWishDel) ||0,
          future: parseFloat(data.slabWishFuture)||0,
          nifty: parseFloat(data.slabWishNifty)||0,
          bankNifty: parseFloat(data.slabWishBankNifty)||0,
          // baseRate: parseFloat(data.slabWishRate),
          optionStock: parseFloat(data.slabWishOptionStock)||0,
          from: 0 || parseFloat(data.slabwiseFrom)||0,
          to: 0 || parseFloat(data.slabwiseTo) ,
        };
      }
    } else if (selectBrokerage === "3") {
      reqObj = {
        // ...sample,
        id: parseFloat(data.id),
        indAMC: parseFloat(data.amcWiseIndAmc),
        indSharing: parseFloat(data.amcWiseIndSharing),
        earningPerAccount: parseFloat(data.amcWiseIndEarnpe),
        corpAMC: parseFloat(data.amcWiseCornpAmc),
        corpSharing: parseFloat(data.amcWiseCornSharing),
        corpEarnPerAC: parseFloat(data.amcWiseCornEarnp),
      };
    } else if (selectBrokerage === "4") {
      if (data?.id == "2") {
        reqObj = {
          // ...sample,
          id: parseFloat(data.id),
          sharing: parseFloat(data.sharing),
          mtfSharing: parseFloat(data.mtfWiseSharing),
          mtfBaseRate: parseFloat(data.mtfWiseBaseRate),
          lasBaseRate: parseFloat(data.lasWiseBaseRate),
          lasSharing: parseFloat(data.lasWiseSharing),
        };
      } else {
        reqObj = {
          // ...sample,
          id: parseFloat(data?.id),
          sharing: parseFloat(data?.sharing)||0,
          trade: parseFloat(data?.brokerageTrade)||0,
          del: parseFloat(data?.brokerageDel)||0,
          future: parseFloat(data?.brokerageFuture)||0,
          nifty: parseFloat(data?.brokerageNifty)||0,
          bankNifty: parseFloat(data?.brokerageBankNifty)||0,
          optionStock: parseFloat(data?.brokerageOptionStock)||0,
          // mtfSharing:
          //   data.mtfWiseSharing === "" ? 0 : parseFloat(data.mtfWiseSharing),
          // mtfBaseRate:
          //   data.mtfWiseBaseRate !== "" ? parseFloat(data.mtfWiseBaseRate) : 0,
          // lasBaseRate:
          //   data.lasWiseBaseRate !== "" ? parseFloat(data.lasWiseBaseRate) : 0,
          // lasSharing:
          //   data.lasWiseSharing !== "" ? parseFloat(data.lasWiseSharing) : 0,
        };
      }
    }
    bodyObj = {
      apcode: apCodeChild,
      brokerage: {
        bid: parseFloat(selectBrokerage),
        modules: reqObj,
      },
      segment: getValues("mainSegment").split(","),
      commUploadFile: fileUrl,
      apType: {
        apId: master === "ApMaster" ? parseFloat(getValues("mainApType")) : 2,
      },
    };

    if (master === "ApMaster") {
      bodyObj.masterAp = subApCode;
      bodyObj.pan = getValues("panNumber");
      bodyObj.accountNo = getValues("bankAccNumber");
      bodyObj.ifscCode = getValues("ifscCode");
      bodyObj.bankName = getValues("bankName");
      bodyObj.isAPRegistered = getValues("apRegister");
      bodyObj.isGSTRegistered = getValues("gstRegister");
      bodyObj.canChequeFile = getValues("inputFileCheque") || "";
      bodyObj.gstNo = getValues("gstNumber") || "";
      bodyObj.sapCode = getValues("sapCodes") || "";
      bodyObj.regNo = getValues("registrationNo") || "";
      bodyObj.gstDocument = getValues("inputFileGst") || "";
      bodyObj.commUploadFile = getValues("inputFileCommercial") || "";
      bodyObj.exchange = exchangeId;

      if (data?.id == "4") {
          bodyObj.brokerageSlab01 = tableData[0]?.brokerage||"";
          bodyObj.apSharing01 = Number(tableData[0]?.apSharing)||0;
          bodyObj.brokerageSlab02 = tableData[1]?.brokerage||"";
          bodyObj.apSharing02 = Number(tableData[1]?.apSharing)||0;;
          bodyObj.brokerageSlab03 = tableData[2]?.brokerage||"";
          bodyObj.apSharing03 = Number(tableData[2]?.apSharing)||0;;
          bodyObj.brokerageSlab04 = tableData[3]?.brokerage||"";
          bodyObj.apSharing04 = Number(tableData[3]?.apSharing)||0;;
          bodyObj.brokerageSlab05=tableData[4]?.brokerage||"";
          bodyObj.apSharing05 = Number(tableData[4]?.apSharing)||0;
      }
    }
    if (master === "ClientMaster") {
      bodyObj.clientCode = ClientCodeRef.current.value;
    }

    let payloadValue = bodyObj;
    let encPayload = AESEncryption(payloadValue);
    console.log("payloadValue ap master", payloadValue)
    try {
      const submitMaster = await axios.post(
        master === "ApMaster"
          ? AP_Master.Submit_ApMaster_URL
          : AP_Master.Submit_ClientMaster_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(submitMaster?.data);
      if (res.status === 0) {
        setImpsVerify(false);
        setUpdateData({});
        setValue("gstRegister", "");
        toast.success(res.data);

        setSubmitBtn(true);
        // setSelectBrokerage("");
        // setSubApDropDown(false);
        resetForm({
          gstNumber: "",
          sapCodes: "",
          registrationNo: "",
          // commercialUpload: "",
          inputFileGst: "",
          inputFileCommercial: "",
          inputFileCheque: "",
          ifscCode: "",
          apRegister: "",
          gstRegister: "",
          panNumber: "",
          bankName: "",
          bankAccNumber: "",
          mainApType: "",
          mainApCode: "",
          // mainProductBrokerage: "",
        });
        clearErrors();
        setExchangeId([]);
        setExchangeName([]);
        setTableData([])
        hiRef.forUpdateName(false);
        hiRef.returnSegmentID();
        // apTypeRef.current.value = "";
        if (master === "ClientMaster") {
          onChangeClientDropdownReset();
        }
        document.querySelector("#Input_Segment").value = "";
        window.scrollTo({ top: 0, behavior: "smooth" });
        // brokerageRef.current.value = "";
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Invalid input parameters");
      console.log(error);
    } finally {
      hiRef.getApMasterListToParent();
    }
  };
  // update and submit api integration end

  const uploadOnAwsApi = async (file, fileType) => {
    if (fileType === "gst") {
      setUploadGstLoader(true);
    }
    if (fileType === "commercial") {
      setLoaderBrowsFile(true);
    }
    if (fileType === "cheque") {
      setCanChequeLoader(true);
    }

    try {
      const formData = new FormData();
      formData.append("fileData", file[0]);

      const declarationData = await axios.post(
        AP_Master.UploadOnAwsFile_URL,
        formData,

        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );
      const res = declarationData?.data;
      if (res?.status === 0) {
        if (fileType === "gst") {
          setValue("inputFileGst", res?.data?.fileName);
          setFileUrl(res?.data?.fileName);
        } else if (fileType === "commercial") {
          setValue("inputFileCommercial", res?.data?.fileName);
          setFileUrl(res?.data?.fileName);
        } else if (fileType === "cheque") {
          setValue("inputFileCheque", res?.data?.fileName);
          setFileUrl(res?.data?.fileName);
        }
      } else {
        toast.error(res?.message);
        if (fileType === "gst") {
          setValue("inputFileGst", "");
        } else if (fileType === "commercial") {
          setValue("inputFileCommercial", "");
        } else if (fileType === "cheque") {
          setValue("inputFileCheque", "");
        }
      }
    } catch (error) {
      if (fileType === "gst") {
        setValue("inputFileGst", "");
      } else if (fileType === "commercial") {
        setValue("inputFileCommercial", "");
      } else if (fileType === "cheque") {
        setValue("inputFileCheque", "");
      }
      toast.error(error?.message);
    } finally {
      if (fileType === "gst") {
        setUploadGstLoader(false);
      }
      if (fileType === "commercial") {
        setLoaderBrowsFile(false);
      }
      if (fileType === "cheque") {
        setCanChequeLoader(false);
      }
    }
  };

  // const handleFileUpload = (e, fileType) => {
  //   const MAX_FILE_SIZE = 1048576 * 5; //100KB

  //   if (e.target.files && e.target.files.length > 0) {
  //     if (e.target.files[0].size <= MAX_FILE_SIZE) {
  //       uploadOnAwsApi(e.target.files, fileType);
  //     } else {
  //       if (fileType === "gst") {
  //         setValue("inputFileGst", "");
  //       } else if (fileType === "commercial") {
  //         setValue("inputFileCommercial", "");
  //       } else if (fileType === "cheque") {
  //         setValue("inputFileCheque", "");
  //       }
  //       toast.error("Please select file less than 5MB");
  //     }
  //   }
  // file check emty or present
  //   const file = e.target.files[0]; // Get the uploaded file
  //   if (file) {
  //     setValue("inputFileCheque", file.name, { shouldValidate: true }); // Update the form value
  //     trigger("inputFileCheque"); // Revalidate the field to clear the error
  //   }
  // };
  const handleFileUpload = (e, fileType) => {
    const MAX_FILE_SIZE = 1048576 * 5;
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > MAX_FILE_SIZE) {
      setValue(getFieldByType(fileType), "");
      toast.error("Please select a file less than 5MB");
      return;
    }
    uploadOnAwsApi(e.target.files, fileType);
    setValue(getFieldByType(fileType), file.name, { shouldValidate: true });
    trigger(getFieldByType(fileType));
  };
  const getFieldByType = (fileType) => {
    const fieldsMap = {
      gst: "inputFileGst",
      commercial: "inputFileCommercial",
      cheque: "inputFileCheque",
    };
    return fieldsMap[fileType] || "";
  };

  // Exchange
  const handleAllCheckExchange = (e) => {
    let ExchangeValue = apDropdown?.exchType;
    setErrorExchange(false);
    if (e.target.checked === true) {
      if (!exchangeId.includes(e.target.value)) {
        setExchangeName(ExchangeValue.map((item) => item.name));
        setExchangeId(ExchangeValue.map((item) => item.id));
      }
    } else {
      exchangeId.forEach((item) => {
        let element = document.getElementById(`exchange-id-${item}`);
        // let elementProps = propsId;
        if (element) {
          element.checked = false;
        }
      });
      setExchangeId([]);
      setExchangeName([]);
    }
  };

  const handleExchangeError = () => {
    // if(localStorage.getItem("accessRole") !== "FranchiseManager"){
    //   toast.error("You dont have access to add details.")
    // }

    setErrorExchange(false);
    if (exchangeId.length > 0) {
      setErrorExchange(false);
    } else {
      setErrorExchange("*Please select Exchange");
    }
  };

  function forUpdateExchangeChild(data) {
    if (data) {
      let exchangeFromName = [];
      let exchangeFromID = [];
      for (let item of data) {
        if (item.id) {
          exchangeFromID.push(parseInt(item.id));
        }
        if (item.name) {
          exchangeFromName.push(item.name);
        }
      }
      setExchangeName(exchangeFromName);
      setExchangeId(exchangeFromID);
      defaultExchangeSet();
    }
  }

  const handleExchangeCheck = (e) => {
    setErrorExchange(false);
    if (e.target.checked === true) {
      if (!exchangeName.includes(e.target.name)) {
        setExchangeName([...exchangeName, e.target.name]);
        setExchangeId([...exchangeId, parseInt(e.target.value)]);
      }
    } else {
      if (exchangeName.includes(e.target.name)) {
        let exchangeNameArray = [...exchangeName];
        let exchangeIdArray = [...exchangeId];
        let i = exchangeName.indexOf(e.target.name);
        let j = exchangeId.indexOf(parseInt(e.target.value));
        exchangeNameArray.splice(i, 1);
        exchangeIdArray.splice(j, 1);
        setExchangeName(exchangeNameArray);
        setExchangeId(exchangeIdArray);
      }
    }
  };

  useEffect(() => {
    if (exchangeName && document.querySelector("#Input_Exchange")) {
      document.querySelector("#Input_Exchange").value = exchangeName.join(",");
    }
  }, [exchangeName]);

  useEffect(() => {
    if (exchangeShow) {
      defaultExchangeSet();
    }
  }, [exchangeShow, exchangeId]);

  const handleClickOutside = (event) => {
    if (
      exchangeDropdownRef.current &&
      !exchangeDropdownRef.current.contains(event.target)
    ) {
      setExchangeShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const defaultExchangeSet = () => {
    let selectAllCheckbox = document.querySelector("#select-all");
    if (selectAllCheckbox) {
      if (exchangeId.length === 4) {
        selectAllCheckbox.checked = true;
      } else {
        selectAllCheckbox.checked = false;
      }
    }
    let deafultSegment = [...exchangeId];
    deafultSegment.forEach((item) => {
      let element = document.getElementById(`exchange-id-${item}`);
      // let elementProps = propsId;
      if (element) {
        element.checked = true;
      }
    });
  };

  const handleIfscModal = () => {
    setShowIfscModal(true);
  };

  const getBankNames = async (bankNameVal, pageNo) => {
    let payloadValue = { search: bankNameVal, pageNo: pageNo, pageSize: 5 };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.BankNames_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getModules?.data);
      if (res?.status === 0) {
        setCount(res?.data?.totalCount);
        setBankNameErr(false);
        setBankErr("");
        if (page > 1) {
          setBankNameData((prev) => {
            return [...prev, ...res?.data?.bankNameList];
          });
        } else {
          setBankNameData(res?.data?.bankNameList);
        }
      } else {
        setBankNameErr(res?.message);
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/");
      }
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  };

  function handleBankName(data) {
    if (data) {
      getBankNames(data, 1);
      setScrollLoader(true);
      setBankNameErr(false);
      setBankNameData([]);
      setPage(1);
    }
  }

  useEffect(() => {
    if (page > 1) {
      getBankNames(bankNameVal, page);
    }
  }, [page]);

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 5 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const closeModal = () => {
    setShow(false);
    setShowBranch(false);
    setBankNameVal("");
    setBranchLocationVal("");
    setShowIfscModal(false);
    setBankErr("");
    setBranchErr("");
  };

  const getBranchLocation = async (branchLocationVal, pageNo) => {
    let payloadValue = {
      search: branchLocationVal,
      pageNo: pageNo,
      pageSize: 5,
      bankName: bankNameVal
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.BranchLocation_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getModules?.data);
      if (response?.status === 0) {
        setBranchCount(response?.data?.totalCount);
        setBranchLocErr(false);
        setBranchErr("");

        if (pageBranch > 1) {
          setBranchLocData((prev) => {
            return [...prev, ...response?.data?.branchNameList];
          });
        } else {
          setBranchLocData(response?.data?.branchNameList);
        }
      } else {
        setBranchLocErr(response?.message);
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/");
      }
      console.log(error);
    } finally {
      setBranchScrollLoader(false);
    }
  };

  function handlebranchLocation(data) {
    if (data) {
      getBranchLocation(data, 1);
      setBranchScrollLoader(true);
      setBranchLocErr(false);
      setBranchLocData([]);
      setPageBranch(1);
    }
  }

  useEffect(() => {
    if (pageBranch > 1) {
      getBranchLocation(branchLocationVal, pageBranch);
    }
  }, [pageBranch]);

  const handleBranchScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(branchCount <= 5 * pageBranch)) {
        setPageBranch((prev) => prev + 1);
        setBranchScrollLoader(true);
      }
    }
  };

  const handleCancelBankBtn = () => {
    setBankNameVal("");
    setBankNameData([]);
    setShow(false);
  };

  const handleCancelBranchBtn = () => {
    setBranchLocationVal("");
    setBranchLocationVal([]);
    setShowBranch(false)
  };

  const getIfscCode = async () => {
    setIfscLoader(true);
    let payloadValue = {
      bankName: bankNameVal,
      branchLoc: branchLocationVal,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.GetIfsc_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getModules?.data);
      if (response?.status === 0) {
        setIfscVal(response?.data);
        closeModal();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/");
      }
      console.log(error);
    } finally {
      setIfscLoader(false);
    }
  };

  const handleIfscBtn = () => {
    setShow(false);
    setShowBranch(false);
    if (bankNameVal?.length > 0) {
      if (branchLocationVal?.length > 0) {
        getIfscCode();
      } else {
        setBranchErr("Please Enter Branch Location");
      }
    } else {
      setBankErr("Please Enter Bank Name");
    }
  };

  const handleIfscInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    if (/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
      setValue("ifscCode", value);
      clearErrors("ifscCode");
      // getBankByIfsc();
    } else {
      setError("ifscCode", {
        type: "manual",
        message: "*Please Enter valid IFSC code without white space",
      });
    }
  };

  useEffect(() => {
    if (ifscVal) {
      setValue("ifscCode", ifscVal);
      clearErrors("ifscCode");
    }
  }, [ifscVal]);

  console.log("ap master table data", tableData)
  const getBankByIfsc = async () => {
    let payloadValue = {
      ifsc: getValues("ifscCode"),
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getModules = await axios.post(
        AP_Master.GetBankNameByIfsc_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const response = ApiResDecrypt(getModules?.data);
      if (response?.status === 0) {
        setBankNameIfsc(response?.data);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/");
      }
      console.log(error);
    }
  };

  useEffect(() => {
    if (getValues("ifscCode")) {
      getBankByIfsc();
    }
  }, [getValues("ifscCode")]);

  useEffect(() => {
    if (bankNameIfsc) {
      setValue("bankName", bankNameIfsc);
      clearErrors("bankName");
    }
  }, [bankNameIfsc]);

  const handleGstRegisterChange = (event) => {
    if (event?.target?.value == "no") {
      setValue("gstRegister", "no")
    }
    setGstRegisterValue(event?.target?.value);
  };

  const handleProceedBtn = () => {
    setValue("inputFileCheque", "")
    setImpsVerify(true);
    setBankVeriModal(false);
  };

  const handleBankNameVal = (e) => {
    if (e?.target?.value?.length == 0) {
      setBankNameData([]);
    }
    setBankNameVal(e?.target?.value.toUpperCase());
    setShow(true);
  }

  const handleBranchlocVal = (e) => {
    if (e?.target?.value?.length == 0) {
      setBranchLocData([]);
    }
    setBranchLocationVal(e?.target?.value.toUpperCase());
    setShowBranch(true);
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <div className="d-none" ref={apCodeFromChildRef}></div>
      <main id="main-content" className="ap-master-wrapper">
        <form onSubmit={handleSubmit(apMasterForm)}>
          <div className="card-box">
            <div className="row input-field-wrapper">
              <div className="col-md-3 col-sm-3 col-12">
                <div className="form-group">
                  <label className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                    }`}>
                    AP Code
                    <span className="partner-mandetory">*</span>
                  </label>
                  <SearchCommon
                    errorMain={errors.mainApCode}
                    forGetApCode={forGetApCode}
                    hiRef={hiRef}
                    GetClientCodes={GetClientCodes}
                    onChangeClientDropdownReset={onChangeClientDropdownReset}
                    api={"ApSearch"}
                    submitBtn={submitBtn}
                    master={master}
                  />
                  <div className="ErrorMsg">{errors.mainApCode?.message}</div>
                </div>
              </div>
              {master === "ClientMaster" && (
                <>
                  <div className="col-md-3 col-sm-3 col-6">
                    <div className="form-group">
                      <label className="form-label">Client Code</label>
                      <>
                        <div className="rm-custom-dropdown">
                          <input
                            type="text"
                            name="search-text"
                            className={`input-st ap ${errors.mainClientCode ? "invalid" : ""
                              }`}
                            placeholder="Search by Name/Code..."
                            autoComplete="off"
                            onFocus={() => showClientList(true)}
                            // value={clientName}
                            {...register("mainClientCode")}
                            ref={ClientCodeRef}
                            onInput={(e) => {
                              handleClientName(e);
                            }}
                          />

                          <button
                            type="button"
                            className="rm-dropdown-btn"
                            onClick={() => setClientShow(!clientShow)}
                          >
                            <span className="icon-right-arrow-triangle"></span>{" "}
                          </button>
                          {clientShow && (
                            <>
                              <ul
                                className="rm-mapping-ap clientMaster-li border-0"
                                onScroll={handleScrollClientName}
                                id="browsers-ClientMaster"
                              >
                                {Object.values(clientDropDown).map(
                                  (item, i) => (
                                    <li
                                      key={i}
                                      onClick={() => {
                                        handleClientMasterBrokerage(
                                          item.clientCode
                                        );
                                        setClientShow(false);
                                      }}
                                    // className="rm-maping-item-wrapper"
                                    >
                                      <div> {item.clientCode}</div>
                                      <div> {item.clientName}</div>
                                    </li>
                                  )
                                )}
                                {scrollClientLoader && (
                                  <div className="loader-center">
                                    <LoaderForSearch />
                                  </div>
                                )}
                                {errorClientName && <li>{errorClientName}</li>}
                              </ul>
                            </>
                          )}
                        </div>
                        <div className="ErrorMsg">
                          {errors.mainClientCode?.message}
                        </div>
                      </>
                    </div>
                  </div>
                </>
              )}

              <div className="col-md-3 col-sm-3 col-6">
                <div
                  className="form-group"
                  onClick={() => hiRef.closeSegmentDropdown()}
                >
                  <label className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                    }`}>
                    Product
                    <span className="partner-mandetory">*</span>
                  </label>
                  <select
                    className="report-custom-select product-select"
                    // className={`report-custom-select product-select ${
                    //   errors.mainProductBrokerage ? "invalid" : ""
                    // }`}
                    {...register("mainProductBrokerage")}
                  >
                    <option
                      value="4"
                      defaultChecked
                      style={{ display: "none" }}
                    >
                      Brokerage
                    </option>
                    {/* <option value="2">Slab Wise</option>
                    <option value="1">MTF/LAS</option>
                    <option value="3">AMC</option> */}
                  </select>
                  {/* <div className="ErrorMsg">
                    {errors.mainProductBrokerage?.message}
                  </div> */}
                </div>
              </div>

              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label
                    className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                      }`}
                  >
                    Segment
                    <span className="partner-mandetory">*</span>
                  </label>
                  <SegmentDropDown
                    segmentValue={apDropdown["segment"]}
                    forSegement={forSegement}
                    hiRef={hiRef}
                    updateData={getValues("mainSegment")}
                    errorMainSegment={errors.mainSegment}
                    bankVeriModal={impsVerify}
                    getRole={getRole}
                  />
                  <div className="ErrorMsg">{errors.mainSegment?.message}</div>
                </div>
              </div>
              <div
                className={`col-md-3 col-sm-3 col-6 ${master === "ClientMaster" && "d-none"
                  } `}
              >
                <div
                  className="form-group"
                  onClick={() => hiRef.closeSegmentDropdown()}
                >
                  <label
                    className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                      }`}
                  >
                    AP type
                    <span className="partner-mandetory">*</span>
                  </label>
                  <select
                    className={`report-custom-select  ${errors.mainApType ? "invalid" : ""
                      }`}
                    {...register("mainApType")}
                    // , {
                    //                       onChange: (e) => apTypeChange(e),
                    //                     })}
                    // ref={apTypeRef}
                    // onChange={apTypeChange}
                    disabled={impsVerify === true || getRole !== "FranchiseManager"}
                  >
                    <option value="">--Select AP Type--</option>
                    <option value="3">AP</option>
                    <option value="2">Master AP</option>
                    <option value="1">Sub AP</option>
                  </select>
                  <div className="ErrorMsg">{errors.mainApType?.message}</div>
                </div>
              </div>
              {getValues("mainApType") == "1" && master === "ApMaster" && (
                <>
                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label className="form-label">Master AP</label>
                      <SearchCommon
                        forGetSubApCode={forGetSubApCode}
                        // forFlagActive={forFlagActive}
                        errorMain={errors.mainSubApType}
                        hiRef={hiRef}
                        api={"SubApSearch"}
                        submitBtn={submitBtn}
                      />
                      <div className="ErrorMsg">
                        {errors.mainSubApType?.message}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {master === "ApMaster" && (
                <>
                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        PAN Number
                        <span className="partner-mandetory">*</span>
                      </label>
                      <div className="rm-custom-dropdown">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={10}
                          className={`input-st ap  ${errors.panNumber ? "invalid" : ""
                            }`}
                          {...register("panNumber")}
                          onInput={(e) => {
                            e.target.value = e.target.value.toUpperCase();
                            inputPanVal(e);
                          }}
                          placeholder="Enter PAN Number..."
                          autoComplete="off"
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                      </div>
                      <div className="ErrorMsg">
                        {errors.panNumber?.message}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        Bank Account Number
                        <span className="partner-mandetory">*</span>
                      </label>
                      <div className="rm-custom-dropdown">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={18}
                          className={`input-st ap  ${errors.bankAccNumber ? "invalid" : ""
                            }`}
                          {...register("bankAccNumber")}
                          onInput={(e) => {
                            e.target.value = e.target.value.toUpperCase();
                          }}
                          placeholder="Enter Bank Acc. Number..."
                          autoComplete="off"
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                      </div>
                      <div className="ErrorMsg">
                        {errors.bankAccNumber?.message}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        IFSC Code
                        <span className="partner-mandetory">*</span>
                      </label>
                      <div className="custom-upload">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={11}
                          className={`input-st ap-ifsc ${errors.ifscCode ? "invalid" : ""
                            }`}
                          defaultValue={getValues("ifscCode")}
                          {...register("ifscCode")}
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase())
                          }
                          onChange={handleIfscInputChange}
                          placeholder="Enter IFSC Code..."
                          autoComplete="off"
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                        <button
                          className="fileUpload btn btn--browse ap-ifsc-btn"
                          type="button"
                          onClick={handleIfscModal}
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        >
                          {ifscLoader ? (
                            <SmallLoader />
                          ) : (
                            <>
                              <img
                                src={searchIfsc}
                                alt="attachment"
                                className
                              />
                              <span>Get IFSC Code</span>
                            </>
                          )}
                        </button>
                      </div>
                      <div className="ErrorMsg">{errors.ifscCode?.message}</div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        Bank Name
                        <span className="partner-mandetory">*</span>
                      </label>
                      <div className="rm-custom-dropdown">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={30}
                          defaultValue={bankNameIfsc}
                          className={`input-st ap  ${errors.bankName ? "invalid" : ""
                            }`}
                          {...register("bankName")}
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase())
                          }
                          placeholder="Enter Bank Name..."
                          autoComplete="off"
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                      </div>
                      <div className="ErrorMsg">{errors.bankName?.message}</div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-3 col-6">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        AP Registered
                        <span className="partner-mandetory">*</span>
                      </label>
                      <select
                        className={`report-custom-select  ${errors.apRegister ? "invalid" : ""
                          }`}
                        {...register("apRegister")}
                        disabled={impsVerify === true || getRole !== "FranchiseManager"}
                      >
                        <option value="">--Yes/No--</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      <div className="ErrorMsg">
                        {errors.apRegister?.message}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        GST Registered
                        <span className="partner-mandetory">*</span>
                      </label>
                      <select
                        className={`report-custom-select  ${errors.gstRegister ? "invalid" : ""
                          }`}

                        {...register("gstRegister")}
                        onChange={(e) => {
                          handleGstRegisterChange(e);
                        }}
                        disabled={impsVerify === true || getRole !== "FranchiseManager"}
                      >
                        <option value="">--Yes/No--</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      <div className="ErrorMsg">
                        {errors.gstRegister?.message}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        GST Number
                        {(gstRegisterValue == "yes" || getValues("gstRegister") == "yes") && (
                          <span className="partner-mandetory">*</span>
                        )}
                      </label>
                      <div className="rm-custom-dropdown">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={15}
                          className={`input-st ap  ${errors.gstNumber ? "invalid" : ""
                            }`}
                          {...register("gstNumber")}
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase())
                          }
                          placeholder="Enter GST Number..."
                          autoComplete="off"
                          disabled={
                            (getValues("gstRegister") !== "yes" && gstRegisterValue !== "yes") || impsVerify === true || getRole !== "FranchiseManager"
                          }
                        />
                      </div>
                      <div className="ErrorMsg">
                        {errors.gstNumber?.message}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        Upload GST Document
                        {(gstRegisterValue == "yes" || getValues("gstRegister") == "yes") && (
                          <span className="partner-mandetory">*</span>
                        )}
                      </label>
                      <div className="custom-upload">
                        <input
                          className="f-input"
                          placeholder="Formats: Excel/PDF"

                          {...register("inputFileGst")}
                          disabled={
                            (getValues("gstRegister") !== "yes" && gstRegisterValue !== "yes") || impsVerify === true || getRole !== "FranchiseManager"
                          }
                        />
                        <div className="fileUpload btn btn--browse">
                          {uploadGstLoader ? (
                            <SmallLoader />
                          ) : (
                            <>
                              <img
                                src={AttachmentFile}
                                alt="attachment"
                                className
                              />
                              <span>Browse File</span>
                            </>
                          )}

                          <input
                            type="file"
                            className="upload"
                            accept=".pdf,.xlsx,.xlsm,.xlsb,.xltx"
                            onChange={(e) => {
                              handleFileUpload(e, "gst");
                            }}
                            disabled={
                              (getValues("gstRegister") !== "yes" && gstRegisterValue !== "yes") || impsVerify === true || getRole !== "FranchiseManager"
                            }
                          />
                        </div>
                      </div>
                      <div className="ErrorMsg">
                        {errors.inputFileGst?.message}
                      </div>
                      <span className="span-custom-uplod">
                        Maximum file size: 5MB
                      </span>
                      {/* )} */}
                    </div>
                  </div>


                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        Commercial Upload
                      </label>
                      <div className="custom-upload">
                        <input
                          // id="uploadFile"
                          className="f-input"
                          placeholder="Formats: Excel/PDF"
                          readOnly
                          {...register("inputFileCommercial")}
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                        <div className="fileUpload btn btn--browse">
                          {loaderBrowsFile ? (
                            <SmallLoader />
                          ) : (
                            <>
                              <img
                                src={AttachmentFile}
                                alt="attachment"
                                className
                              />
                              <span>Browse File</span>
                            </>
                          )}

                          <input
                            type="file"
                            className="upload"
                            accept=".pdf,.xlsx,.xlsm,.xlsb,.xltx"
                            onChange={(e) => {
                              handleFileUpload(e, "commercial");
                            }}
                            disabled={impsVerify === true || getRole !== "FranchiseManager"}
                          />
                        </div>
                      </div>
                      {/* {errors?.commercialUpload ? (
                        <div className="ErrorMsg">
                          {errors.commercialUpload?.message}
                        </div>
                      ) : ( */}
                      <span className="span-custom-uplod">
                        Maximum file size: 5MB
                      </span>
                      {/* )} */}
                    </div>
                  </div>
                  {/* Exchange */}
                  <div className="col-md-3 col-sm-3 col-6">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        Exchange
                      </label>
                      <div
                        className="rm-custom-dropdown"
                        ref={exchangeDropdownRef}
                      >
                        <input
                          type="text"
                          name="search-text"
                          id="Input_Exchange"
                          // className={`input-st ap cursor-point ${
                          //   errorExchange ? "invalid" : ""
                          // }`}
                          className="input-st ap cursor-point"
                          placeholder="--Select Exchange--"
                          autoComplete="off"
                          readOnly
                          onClick={() => {
                            setExchangeShow(!exchangeShow);
                          }}
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                        <button
                          type="button"
                          className="rm-dropdown-btn"
                          onClick={() => {
                            setExchangeShow(!exchangeShow);
                          }}
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        >
                          <span className="icon-right-arrow-triangle"></span>
                        </button>
                        {exchangeShow && (
                          <>
                            <ul
                              className="rm-mapping-ap apSearch border-0"
                              id="browsers-Rm"
                            >
                              <li className="rm-maping-item-wrapper">
                                <input
                                  type="checkbox"
                                  name="select-all"
                                  className="exchangeCheckbox"
                                  value="select"
                                  id="select-all"
                                  onChange={handleAllCheckExchange}
                                />
                                <label htmlFor="select-all"> </label>
                                <span className="for-label">Select All</span>
                              </li>
                              {apDropdown &&
                                apDropdown?.exchType?.map((item, key) => {
                                  return (
                                    <>
                                      <li
                                        className="rm-maping-item-wrapper"
                                        key={key}
                                      >
                                        <input
                                          type="checkbox"
                                          name={item.name}
                                          className="segmentCheckbox"
                                          value={item.id}
                                          id={`exchange-id-${item.id}`}
                                          onChange={handleExchangeCheck}
                                        />
                                        <label
                                          htmlFor={`exchange-id-${item.id}`}
                                        ></label>
                                        <span className="for-label">
                                          {item.name}
                                        </span>
                                      </li>
                                    </>
                                  );
                                })}
                            </ul>
                          </>
                        )}
                      </div>
                      {/* <div className="ErrorMsg">{errorExchange}</div> */}
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        SAP Code
                      </label>
                      <div className="rm-custom-dropdown">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={15}
                          className={`input-st ap  ${errors.sapCodes ? "invalid" : ""
                            }`}
                          {...register("sapCodes")}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(/^\s+/, "").toUpperCase())
                          }
                          placeholder="Enter SAP code"
                          autoComplete="off"
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-3 col-12">
                    <div className="form-group">
                      <label
                        className={`form-label ${(impsVerify === true || getRole !== "FranchiseManager") && "disable-label"
                          }`}
                      >
                        Registration number
                      </label>
                      <div className="rm-custom-dropdown">
                        <input
                          type="text"
                          name="search-text"
                          maxLength={15}
                          className={`input-st ap  ${errors.registrationNo ? "invalid" : ""
                            }`}
                          {...register("registrationNo")}
                          onInput={(e) =>
                            (e.target.value = e.target.value.replace(/^\s+/, "").toUpperCase())
                          }
                          placeholder="Enter registration number"
                          autoComplete="off"
                          disabled={impsVerify === true || getRole !== "FranchiseManager"}
                        />
                      </div>
                    </div>
                  </div>
                  {impsVerify === true && (
                    <div className="col-md-3 col-sm-3 col-12">
                      <div className="form-group">
                        <label className="form-label">
                          Upload Cancelled Cheque
                          <span className="partner-mandetory">*</span>
                        </label>
                        <div className="custom-upload">
                          <input
                            // id="uploadFile"
                            className="f-input"
                            placeholder="Formats: Excel/PDF"
                            // readOnly
                            {...register("inputFileCheque")}
                            disabled={impsVerify === true || getRole !== "FranchiseManager"}
                          />
                          <div className="fileUpload btn btn--browse">
                            {canChequeLoader ? (
                              <SmallLoader />
                            ) : (
                              <>
                                <img
                                  src={AttachmentFile}
                                  alt="attachment"
                                  className
                                />
                                <span>Browse File</span>
                              </>
                            )}

                            <input
                              type="file"
                              className="upload"
                              accept=".pdf,.xlsx,.xlsm,.xlsb,.xltx"
                              onChange={(e) => {
                                handleFileUpload(e, "cheque");
                              }}
                            />
                          </div>
                        </div>
                        <div className="ErrorMsg">
                          {errors.inputFileCheque?.message}
                        </div>
                        <span className="span-custom-uplod">
                          Maximum file size: 5MB
                        </span>
                        {/* )} */}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
            <div>

              {getValues("mainProductBrokerage") === "4" && (
                <BrokerageTableApMaster
                  brokerageApi={
                    apDropdown !== undefined || null
                      ? filterBidName(apDropdown["brokerage"], "Brokerage")
                      : ""
                  }
                  biRef={biRef}
                  updateData={updateData}
                  submitBtn={submitBtn}
                  setTableData={setTableData}
                  tableData={tableData}
                />
              )}
            </div>
            <div
              className="save-reset-btn"
              onClick={() => {
                hiRef.closeSegmentDropdown();
                hiRef.forCloseLi([]);
              }}
            >
              <button
                type="submit"
                className="margin-save-btn"
                onClick={handleExchangeError}
                disabled={getRole == "FranchiseManager" ? false : true}
              >
                {submitBtn ? Constants.Submit : "Update"}
              </button>
              <button
                type="button"
                className="margin-reset-btn"
                onClick={resetButton}
                disabled={getRole == "FranchiseManager" ? false : true}
              >
                Cancel
              </button>
            </div>
            {/* <hr /> */}
            <div
              onClick={() => {
                hiRef.forCloseLi([]);
                hiRef.closeSegmentDropdown();
              }}
            >
              <Mastertable
                forUpdateMaster={forUpdateMaster}
                hiRef={hiRef}
                masterSet={masterSet}
                reset={resetButton}
                checkAccess={checkAccess}
              />
            </div>
          </div>
        </form>
      </main>
      <Modal
        show={showIfscModal}
        onHide={closeModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model naked-debit-model-wrapper ifsc-Modal"
        backdrop="static"
        keyboard={false}
      >
        <button
          type="button"
          className="btn-close ifsc-modal-btn"
          aria-label="Close"
          onClick={closeModal}
        >
          <span className="icon-close"></span>
        </button>
        <Modal.Header className="modal-header ifsc-modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <p className="ifsc-modal-title">IFSC Finder</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ifsc-modal-body">
            <p className="body-title">
              Enter your bank name and branch location to find your IFSC code.
            </p>
          </div>
          <div className="wrap-form-group">
            <div className="form-group">
              <label className="form-label">Bank Name</label>
              <div className="rm-custom-dropdown">
                <img src={searchIcon} alt="search" />
                <input
                  type="text"
                  name="search-text"
                  className="input-st ap"
                  value={bankNameVal}
                  onChange={(e) => handleBankNameVal(e)}

                  placeholder="Type your bank name to search"
                  autoComplete="off"
                />
                {show === true ? (
                  <button
                    type="button"
                    className="btn-close input-close"
                    onClick={handleCancelBankBtn}
                  >
                    <span className="icon-close"></span>
                  </button>
                ) : (
                  ""
                )}

                {show && bankNameVal?.length > 0 && (
                  <>
                    <ul
                      className="rm-mapping-ap border-0 ap-master-ul"
                      onScroll={(e) => handleScroll(e)}
                    >
                      {bankNameData &&
                        bankNameData.map((item, i) => (
                          <li
                            key={i}
                            className="rm-maping-item-wrapper"
                            onClick={() => {
                              setBankNameVal(item?.bankName);
                              setShow(false);
                            }}
                          >
                            <div> {item?.bankName}</div>
                            {/* <div> {item?.clientCode}</div> */}
                          </li>
                        ))}
                      {scrollLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {bankNameErr && !scrollLoader && (
                        <li
                          className="rm-maping-item-wrapper"
                          style={{
                            borderBottom: "none",
                            fontSize: "12px",
                          }}
                        >
                          {bankNameErr}
                        </li>
                      )}
                    </ul>
                  </>
                )}
              </div>
              <span className="ErrorMsg">{bankErr}</span>
            </div>
            <div className="form-group">
              <label className="form-label">Branch Location</label>
              <div className="rm-custom-dropdown">
                <img src={searchIcon} alt="search" />
                <input
                  type="text"
                  name="search-text"
                  className="input-st ap"
                  value={branchLocationVal}
                  onChange={(e) => handleBranchlocVal(e)}
                  placeholder="Type your branch area or location to search"
                  autoComplete="off"
                />

                {showBranch === true ? (
                  <button
                    type="button"
                    className="btn-close input-close"
                    onClick={handleCancelBranchBtn}
                  >
                    <span className="icon-close"></span>
                  </button>
                ) : (
                  ""
                )}

                {showBranch && branchLocationVal?.length > 0 && (
                  <>
                    <ul
                      className="rm-mapping-ap border-0 ap-master-ul"
                      onScroll={(e) => handleBranchScroll(e)}
                    >
                      {branchLocData &&
                        branchLocData.map((item, i) => (
                          <li
                            key={i}
                            className="rm-maping-item-wrapper"
                            onClick={() => {
                              setBranchLocationVal(item?.branchLoc);
                              setShowBranch(false);
                            }}
                          >
                            <div> {item?.branchLoc}</div>
                          </li>
                        ))}
                      {scrollBranchLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {branchLocErr && !scrollBranchLoader && (
                        <li
                          className="rm-maping-item-wrapper"
                          style={{
                            borderBottom: "none",
                            fontSize: "12px",
                          }}
                        >
                          {branchLocErr}
                        </li>
                      )}
                    </ul>
                  </>
                )}
              </div>
              <span className="ErrorMsg">{branchErr}</span>
            </div>
            <button class="form-submit" type="submit" onClick={handleIfscBtn}>
              GET IFSC
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={bankVeriModal}
        onHide={() => setBankVeriModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model ifsc-Modal bank-verify-modal"
        backdrop="static"
        keyboard={false}
      >
        <button
          type="button"
          className="btn-close ifsc-modal-btn"
          aria-label="Close"
          onClick={() => setBankVeriModal(false)}
        >
          <span className="icon-close"></span>
        </button>
        <Modal.Header className="modal-header ifsc-modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <span className="icon-close circle-icon"></span>
            <p className="ifsc-modal-title">Bank Verification failed!</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ifsc-modal-body">
            <p className="body-title">
              We could not verify the bank details due to some technical issue
              from bank’s end. Please upload cancelled cheque to verify bank
              details
            </p>
          </div>
          <button class="form-submit" type="submit" onClick={handleProceedBtn}>
            PROCEED
          </button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ApMaster;
